module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mv-91b2c27c9c550f55860739fda63e1ec9.svg";